import { Container, ContainerProps } from '@chakra-ui/react';
import { ReactNode, forwardRef, useState } from 'react';
import { AccountGlobalSearch } from '../Account/GlobalAccountSearch';
import { MFlex } from './chakra';

const DEFAULT_PROPS: ContainerProps = {
  minHeight: '100vh',
  centerContent: true,
  width: 'auto',
  px: ['4px', '4px', '32px'],
  pt: ['24px', '24px', '32px'],
  maxWidth: '100%',
};

const DEFAULT_PROPS_WITH_ACCOUNT_SEARCH: ContainerProps = {
  ...DEFAULT_PROPS,
  minHeight: 'calc(100vh - 125px)',
  pt: '6px',
};

interface MPageContainerProps extends ContainerProps {
  enableAccountSearch?: boolean;
  children?: ReactNode;
}

export const MPageContainer = forwardRef<any, MPageContainerProps>(
  (
    { enableAccountSearch = false, children, ...rest }: MPageContainerProps,
    ref,
  ) => {
    const [containerClicked, setContainerClicked] = useState(false);

    /** Honor feature flag in addition to passed in setting */
    const props = enableAccountSearch
      ? DEFAULT_PROPS_WITH_ACCOUNT_SEARCH
      : DEFAULT_PROPS;

    return (
      <>
        {enableAccountSearch && (
          <MFlex
            style={{ cursor: 'text' }}
            onBlur={() => setContainerClicked(false)}
            onClick={() => setContainerClicked(true)}
            top={0}
            position="sticky"
            width="100%"
            height="100%"
            zIndex={5}
            h={16}
            pl={4}
            pr={4}
            mb={3}
            backgroundColor="tGray.sidebarDark"
          >
            <AccountGlobalSearch containerClicked={containerClicked} />
          </MFlex>
        )}
        <Container ref={ref} {...props} {...rest}>
          {children}
        </Container>
      </>
    );
  },
);

export default MPageContainer;
